import { Link } from "../lib/route";
import { Phone, CalendarPlus } from "lucide-react";
import { SITE } from "../lib/_data";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[#e5e0d8] bg-[#fffdf9]/95 backdrop-blur-lg px-3 py-3 gap-2 shadow-[0_-8px_24px_rgba(44,42,41,0.08)] ${SITE.phone ? "grid grid-cols-2" : "flex"}`}
    >
      {SITE.phone && (
        <a
          href={SITE.phoneHref}
          data-testid="sticky-call-btn"
          className="flex items-center justify-center gap-2 border-2 border-[#2c2a29] text-[#2c2a29] rounded-full py-3 font-bold text-sm"
        >
          <Phone className="w-4 h-4" strokeWidth={2.4} />
          Call Now
        </a>
      )}
      <Link
        to="/consultations"
        data-testid="sticky-book-btn"
        className={`flex items-center justify-center gap-2 bg-[#c85a3c] text-[#fffdf9] rounded-full py-3 font-bold text-sm shadow-[0_6px_16px_rgba(200,90,60,0.4)] ${SITE.phone ? "" : "flex-1"}`}
      >
        <CalendarPlus className="w-4 h-4" strokeWidth={2.4} />
        Book Consult
      </Link>
    </div>
  );
}
